export const API_URL = "https://api-legacy.revellx-engine.pl/";
